const routes = {
  reservations: 'הזמנות',
};

export default routes;
